import { Col, Row } from 'react-bootstrap';
import OutletDetailField from './outlet-detail-field';
import {dateTimeFormatUK} from '../../../utils/commonFunctions';

const OutletDetails = ({ details, id }) => (
  <div className="container-fluid">
    <Row>
      <Col md={6}>
        <Row>
          <OutletDetailField data={id} label="OutletID"/>
          <OutletDetailField data={details['customer-number']} label="Customer Number"/>
          <OutletDetailField data={details.name} label="Store Name"/>
          <OutletDetailField
            data={(
              <div>
                <div>
                  {details['address-1']}
                </div>
                <div>
                  {details['address-2']}
                </div>
                <div>
                  {details['address-3']}
                </div>
                <div>
                  {details.town}
                </div>
                <div>
                  {details.county}
                </div>
                <div>
                  {details.eircode}
                </div>
              </div>
            )}
            label="Store address"
          />
          <OutletDetailField data={details['reward-store'] ? 'Yes' : 'No'} label="Reward Store"/>
          <OutletDetailField data={details['mini-chain']} label="Mini Chain" />
          <OutletDetailField data={details['kace-name']} label="Kace name" />
        </Row>
      </Col>
      <Col md={6}>
        <Row>
          <OutletDetailField data={details['updated-name']} label="Updated store name"/>
          <OutletDetailField
            data={(
              <div>
                <div>
                  {details['updated-address-1']}
                </div>
                <div>
                  {details['updated-address-2']}
                </div>
                <div>
                  {details['updated-address-3']}
                </div>
                <div>
                  {details['updated-town']}
                </div>
                <div>
                  {details['updated-county']}
                </div>
                <div>
                  {details['updated-eircode']}
                </div>
              </div>
            )}
            label="Updated store address"
          />
          {
            details['abm-code'] && (
              <OutletDetailField
                data={details['abm-code']}
                label="ABM Region"
              />
            )}
          {
            details.representative && (
              <OutletDetailField
                data={details.representative}
                label="Imperial Brands Representative"
              />
            )}
          <OutletDetailField
            data={dateTimeFormatUK(details['date-latest-linking'])}
            label="Date of latest linking"
          />
          <OutletDetailField
            data={dateTimeFormatUK(details['date-latest-delinking'])}
            label="Date of latest delinking"
          />
        </Row>
      </Col>
    </Row>
  </div>
);

export default OutletDetails;
